import { useEffect } from 'react';
import { useViewAsanaProjectsQuery } from '../services/api';
import { errorToast } from '../utils/toasts';

/**
 * Fetch asana projects (acceptable params are id)
 * The parameters are optional
 */
export const useFetchAsanaProjects = ({ id } = {}) => {
  const { data, error, isError, isFetching, isLoading } = useViewAsanaProjectsQuery({
    id,
  });

  useEffect(() => {
    if (isError) {
      errorToast('Unable to fetch asana projects. Please try again later.');
      console.error(error);
    }
  }, [error, isError]);

  return {
    data,
    isError,
    isFetching,
    isLoading,
    projects: data && data.projects ? data.projects : [],
  };
};
